<template>
    <div class="cascader">
        <div class="selected-display" @click="toggleDropdown"
            :class="{ 'text-grey': isDefaultText, 'text-black': !isDefaultText }">
            <span>{{ selectedText }}</span>
        </div>
        <div v-show="showDropdown" class="dropdown">
            <div class="dropdown-content-wrapper">
                <div class="dropdown-content">
                    <div class="column" ref="provinceColumn">
                        <div v-for="(province, index) in provinceList" :key="index" @click="selectProvince(province)"
                            :class="{ 'dropdown-item': true, 'selected': selectedProvince.id === province.id }">
                            {{ province.name }}
                        </div>
                    </div>
                    <div class="column" v-if="selectedProvince.id" ref="cityColumn">
                        <div v-for="city in cityList" :key="city.id" @click="selectCity(city)"
                            :class="{ 'dropdown-item': true, 'selected': selectedCity.id === city.id }">
                            {{ city.name }}
                        </div>
                    </div>
                    <div class="column" v-if="selectedCity.id" ref="districtColumn">
                        <div v-for="district in districtList" :key="district.id" @click="selectDistrict(district)"
                            :class="{ 'dropdown-item': true, 'selected': selectedDistrict.id === district.id }">
                            {{ district.name }}
                        </div>
                    </div>
                    <div class="column" v-if="selectedDistrict.id && townList.length > 1" ref="townColumn">
                        <div v-for="town in townList" :key="town.id" @click="selectTown(town)"
                            :class="{ 'dropdown-item': true, 'selected': selectedTown.id === town.id }">
                            {{ town.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CascaderAddress',
    data() {
        return {
            showDropdown: false,
            provinceList: [],
            cityList: [],
            districtList: [],
            townList: [],
            selectedProvince: {},
            selectedCity: {},
            selectedDistrict: {},
            selectedTown: {},
            region: {
                province_id: '',
                city_id: '',
                district_id: '',
                town_id: 0,
                provinceName: '',
                cityName: '',
                districtName: '',
                townName: ''
            },
            scrollPositions: {
                province: 0,
                city: 0,
                district: 0,
                town: 0
            }
        }
    },
    computed: {
        selectedText() {
            const provinceName = this.selectedProvince && this.selectedProvince.name ? this.selectedProvince.name : '请选择省';
            const cityName = this.selectedCity && this.selectedCity.name ? this.selectedCity.name : '请选择市';
            const districtName = this.selectedDistrict && this.selectedDistrict.name ? (this.selectedDistrict.id === 1 ? '' : this.selectedDistrict.name) : '请选择区/县';
            const townName = this.selectedTown && this.selectedTown.name ? (this.selectedTown.id === 1 ? '' : this.selectedTown.name) : '';

            return `${provinceName} / ${cityName} / ${districtName} / ${townName}`;
        },
        isDefaultText() {
            return !this.selectedProvince.id;
        }
    },
    created() {
        this.getProvinceList();
        this.$EventBus.$on('regionIDs', async arr => {
            this.selectedProvince = {};
            this.selectedCity = {};
            this.selectedDistrict = {};
            this.selectedTown = {};
            await this.selectById(arr);
            this.$nextTick(() => {
                this.scrollToSelected();
            });
        });
        this.$EventBus.$on('CloseCascaderAddress', isShow => this.showDropdown = isShow);
    },

    methods: {
        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
            if (this.showDropdown) {
                this.$nextTick(() => {
                    document.querySelector('.dropdown').classList.add('show');
                    this.$nextTick(() => {
                        this.scrollToSelected();
                    });
                });
            } else {
                document.querySelector('.dropdown').classList.remove('show');
            }
        },

        selectProvince(province) {
            this.selectedProvince = province;
            this.selectedCity = {};
            this.selectedDistrict = {};
            this.selectedTown = {};
            this.getCityList(province.id).then(() => {
                this.region.province_id = province.id;
                this.region.provinceName = province.name;
                this.$emit('change', this.region);
                this.saveScrollPosition('province');
                this.$nextTick(() => {
                    this.scrollToSelected() //dom执行完调用滚动
                })
            })
        },

        selectCity(city) {
            this.selectedCity = city;
            this.selectedDistrict = {};
            this.selectedTown = {};
            this.getDistrictList(city.id).then(() => {
                this.region.city_id = city.id;
                this.region.cityName = city.name;
                this.$emit('change', this.region);
                this.saveScrollPosition('city');
                this.$nextTick(() => {
                    this.scrollToSelected();
                });
            });
        },

        selectDistrict(district) {
            this.selectedDistrict = district;
            this.selectedTown = {};
            this.getTownList(district.id).then(() => {
                this.showDropdown = this.townList.length > 1;
                if (district.id === 1) {
                    this.region.district_id = 0;
                    this.region.districtName = '';
                    this.region.town_id = 0;
                    this.region.townName = '';
                } else {
                    this.region.district_id = district.id;
                    this.region.districtName = district.name;
                }
                this.$emit('change', this.region);
                this.saveScrollPosition('district');
                this.$nextTick(() => {
                    this.scrollToSelected();
                });
            });
        },

        selectTown(town) {
            this.selectedTown = town;
            this.showDropdown = false;
            if (town.id === 1) {
                this.region.town_id = 0;
                this.region.townName = '';
            } else {
                this.region.town_id = town.id;
                this.region.townName = town.name;
            }
            this.$emit('change', this.region);
            this.saveScrollPosition('town');
            this.$nextTick(() => {
                this.scrollToSelected();
            });
        },
        getProvinceList() {
            this.cityList = [];
            this.districtList = [];
            this.townList = [];
            this.$util.api('/region', {}, res => {
                if (res.code == 10000 && res.data) {
                    this.provinceList = res.data.map(province => ({
                        name: province.fullname,
                        id: province.id
                    }));
                } else {
                    this.provinceList = [];
                }
            });
        },
        getCityList(province_id) {
            this.cityList = [];
            this.districtList = [];
            this.townList = [];
            return new Promise(resolve => {
                this.$util.api('/region', { id: province_id }, res => {
                    if (res.code == 10000 && res.data) {
                        this.cityList = res.data.map(city => ({
                            name: city.fullname,
                            id: city.id
                        }));
                    } else {
                        this.cityList = [];
                    }
                    resolve();
                });
            });
        },
        getDistrictList(city_id) {
            this.districtList = [];
            this.townList = [];
            return new Promise(resolve => {
                this.$util.api('/region', { id: city_id }, res => {
                    if (res.code == 10000 && res.data) {
                        this.districtList = res.data.map(district => ({
                            name: district.fullname,
                            id: district.id
                        }));
                        this.districtList.unshift({
                            name: '暂不选择',
                            id: 1
                        });
                    } else {
                        this.districtList = [];
                    }
                    resolve();
                });
            });
        },
        getTownList(district_id) {
            this.townList = [];
            return new Promise(resolve => {
                this.$util.api('/region', { id: district_id }, res => {
                    if (res.code == 10000 && res.data) {
                        if (res.data.length > 0) {
                            this.townList = res.data.map(town => ({
                                name: town.fullname,
                                id: town.id
                            }));
                        }
                        this.townList.unshift({
                            name: '暂不选择',
                            id: 1
                        });
                    } else {
                        this.townList = [];
                    }
                    resolve();
                });
            });
        },
        async selectById(arr) {
            if (arr[0].length) {
                await this.selectProvinceById(arr[0]);
                if (arr[1].length) {
                    await this.selectCityById(arr[1]);
                    if (arr[2].length) {
                        await this.selectDistrictById(arr[2]);
                        if (arr[3].length) {
                            await this.selectTownById(arr[3]);
                        }
                    }
                }
            }
        },
        selectProvinceById(provinceId) {
            return new Promise(resolve => {
                this.getCityList(provinceId).then(() => {
                    this.selectedProvince = this.provinceList.find(province => province.id == provinceId);
                    if (this.selectedProvince) {
                        this.region.province_id = provinceId;
                        this.region.provinceName = this.selectedProvince.name;
                        this.$emit('change', this.region);
                    }
                    resolve();
                    this.saveScrollPosition('province');
                });
            });
        },
        selectCityById(cityId) {
            return new Promise(resolve => {
                this.getDistrictList(cityId).then(() => {
                    this.selectedCity = this.cityList.find(city => city.id == cityId);
                    if (this.selectedCity) {
                        this.region.city_id = cityId;
                        this.region.cityName = this.selectedCity.name;
                        this.$emit('change', this.region);
                    }
                    resolve();
                    this.saveScrollPosition('city');
                });
            });
        },
        selectDistrictById(districtId) {
            return new Promise(resolve => {
                this.getTownList(districtId).then(() => {
                    this.selectedDistrict = this.districtList.find(district => district.id == districtId);
                    if (this.selectedDistrict) {
                        this.region.district_id = districtId;
                        this.region.districtName = this.selectedDistrict.name;
                        this.$emit('change', this.region);
                    }
                    resolve();
                    this.saveScrollPosition('district');
                });
            });
        },
        selectTownById(townId) {
            this.selectedTown = this.townList.find(town => town.id == townId);
            if (this.selectedTown) {
                this.region.town_id = townId;
                this.region.townName = this.selectedTown.name;
                this.$emit('change', this.region);
            }
            this.saveScrollPosition('town');
        },
        saveScrollPosition(type) {
            this.$nextTick(() => {
                if (type === 'province') {
                    this.scrollPositions.province = this.$refs.provinceColumn ? this.$refs.provinceColumn.scrollTop : 0;
                } else if (type === 'city') {
                    this.scrollPositions.city = this.$refs.cityColumn ? this.$refs.cityColumn.scrollTop : 0;
                } else if (type === 'district') {
                    this.scrollPositions.district = this.$refs.districtColumn ? this.$refs.districtColumn.scrollTop : 0;
                } else if (type === 'town') {
                    this.scrollPositions.town = this.$refs.townColumn ? this.$refs.townColumn.scrollTop : 0;
                }
            });
        },
        restoreScrollPosition() {
            this.$nextTick(() => {
                if (this.$refs.provinceColumn) {
                    this.$refs.provinceColumn.scrollTop = this.scrollPositions.province;
                }
                if (this.$refs.cityColumn) {
                    this.$refs.cityColumn.scrollTop = this.scrollPositions.city;
                }
                if (this.$refs.districtColumn) {
                    this.$refs.districtColumn.scrollTop = this.scrollPositions.district;
                }
                if (this.$refs.townColumn) {
                    this.$refs.townColumn.scrollTop = this.scrollPositions.town;
                }
            });
        },
        scrollToSelected() {
            this.$nextTick(async () => {
                const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

                const tryScroll = async (ref, retries = 3) => {
                    for (let i = 0; i < retries; i++) {
                        const element = this.$refs[ref] ? this.$refs[ref].querySelector('.selected') : null
                        if (element) {
                            element.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
                            await delay(200)
                            return
                        }
                        await delay(100)
                    }
                };

                await tryScroll('provinceColumn')
                await tryScroll('cityColumn')
                await tryScroll('districtColumn')
                await tryScroll('townColumn')
            })
        }

    }
}

</script>

<style lang="less" scoped>
.cascader {
    width: 100%;
    border-radius: 4px;
    height: 35px;
    border: 1px solid #ccc;
    position: relative;
    cursor: pointer;
    background-color: #fff;

    .selected-display {
        padding: 0 10px;
        line-height: 35px;

        &.text-grey {
            color: rgba(0, 0, 0, .3);
        }

        &.text-black {
            color: unset;
        }
    }
}

.dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    border: 1px solid #ccc;
    background: #fff;
    z-index: 1000;
    min-height: 180px;

    .dropdown-content-wrapper {
        overflow-y: auto;
        max-height: 180px;
        overscroll-behavior: contain;
    }

    .dropdown-content {
        display: flex;

        .column {
            flex: 1;
            border-right: 1px solid #ccc;
            max-height: 180px;
            overflow-y: auto;

            &:last-child {
                border-right: none;
            }

            .dropdown-item {
                height: 30px;
                line-height: 30px;
                white-space: nowrap;
                text-align: center;
                cursor: pointer;

                &:hover {
                    background: #f5f5f5;
                }

                &.selected {
                    background: #f5f5f5;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/address/CascaderAddress.vue